import { render, staticRenderFns } from "./basketItem.vue?vue&type=template&id=1a4262bb"
import script from "./basketItem.vue?vue&type=script&lang=js"
export * from "./basketItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports